import { schema } from "normalizr";

const ResignationSchema = new schema.Entity("resignations");
const ResignationArraySchema = new schema.Array(ResignationSchema);

export { ResignationSchema, ResignationArraySchema };
